interface AuthoritativeFields<TStatus extends string = string> {
  status?: TStatus;
  name?: string;
}

/**
 * After a PATCH we refresh the store with a GET, but that read can hit an eventually-consistent
 * replica and return the pre-PATCH status/name — leaving the badge/header on the old value. The
 * fields we just PATCHed are authoritative: overlay them on the reloaded entity when the read
 * comes back stale.
 */
export function mergeAuthoritativeFields<T extends AuthoritativeFields<TStatus>, TStatus extends string = string>(
  reloaded: T,
  patched: AuthoritativeFields<NoInfer<TStatus>>,
): { merged: T; diverged: boolean } {
  const overlay: AuthoritativeFields<TStatus> = {};
  if (patched.status !== undefined && reloaded.status !== patched.status) {
    overlay.status = patched.status;
  }
  if (patched.name !== undefined && reloaded.name !== patched.name) {
    overlay.name = patched.name;
  }
  const diverged = Object.keys(overlay).length > 0;
  return { merged: diverged ? { ...reloaded, ...overlay } : reloaded, diverged };
}
